import { render } from "./Proveedor.vue?vue&type=template&id=d0caa280&scoped=true"
import script from "./Proveedor.vue?vue&type=script&lang=js"
export * from "./Proveedor.vue?vue&type=script&lang=js"

import "./Proveedor.vue?vue&type=style&index=0&id=d0caa280&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0caa280"]])

export default __exports__